// extracted by mini-css-extract-plugin
export default {"SocialLinks":"SocialLinks__SocialLinks__QORol","SocialLinks__icons":"SocialLinks__SocialLinks__icons__sFtVn","SocialLinks__icon":"SocialLinks__SocialLinks__icon__M8v9G"};